<stx-generic-page>
  <stx-report-header>{{ title | translate }}</stx-report-header>

  <stx-notice noticeType="success" [@successNotice]="successNoticeVisible ? 'visible' : 'hidden'">
    {{ 'report.file_export_success_message' | translate }}
  </stx-notice>

  <stx-report-filters [leftColumnInfoTemplate]="info" [reportConfig]="reportConfig" (applyFilters)="downloadReport()"></stx-report-filters>

  <ng-template #info>
    {{ 'reports.partner_surgery_counts.notice' | translate }}
  </ng-template>
</stx-generic-page>
